// extracted by mini-css-extract-plugin
export default {"jpRunning":"JP_Footer_jpRunning__h1ZkL","jpCurrentDate":"JP_Footer_jpCurrentDate__wxwAO","jpFootage":"JP_Footer_jpFootage__jEoZ4","higlight":"JP_Footer_higlight__sV1+e"};